function initializeAdagioOrdering(scope = document) {
  scope.querySelectorAll('[data-adagio-order-controls]').forEach((controls) => {
    if (controls.dataset.initialized) return;
    controls.dataset.initialized = 'true';
    const select = controls.querySelector('[data-adagio-variant]');
    if (!select) return;
    const product = controls.closest('[data-adagio-product]');
    const quantity = controls.querySelector('[data-adagio-quantity]');
    const add = controls.querySelector('[data-adagio-add]');
    const stock = controls.querySelector('[data-adagio-stock]');

    const update = (changeUrl = false) => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const min = Math.max(1, Number(option.dataset.min) || 1);
      const step = Math.max(1, Number(option.dataset.step) || 1);
      const max = option.dataset.max === '' ? null : Number(option.dataset.max);
      const available = option.dataset.available === 'true' && (max === null || max >= min);
      quantity.min = String(min);
      quantity.step = String(step);
      if (max === null) quantity.removeAttribute('max');
      else quantity.max = String(max);
      const requested = Number(quantity.value) || min;
      let value = min + Math.max(0, Math.floor((requested - min) / step)) * step;
      if (max !== null && max >= min) value = Math.min(value, min + Math.floor((max - min) / step) * step);
      quantity.value = String(value);
      quantity.disabled = !available;
      add.disabled = !available;
      add.textContent = available ? 'Add to cart' : 'Sold out';
      stock.textContent = available ? 'In stock' : 'This colour is currently sold out.';
      product.querySelector('[data-adagio-product-price]').textContent = option.dataset.price;
      const preview = product.querySelector('[data-adagio-variant-preview]');
      if (preview) {
        const image = preview.querySelector('img');
        preview.hidden = !option.dataset.imageUrl;
        if (option.dataset.imageUrl) {
          image.removeAttribute('srcset');
          image.src = option.dataset.imageUrl;
          image.alt = option.dataset.imageAlt || option.textContent.trim();
          image.width = Number(option.dataset.imageWidth);
          image.height = Number(option.dataset.imageHeight);
          preview.querySelector('[data-adagio-variant-caption]').textContent = option.textContent.trim();
        }
      } else if (!product.hasAttribute('data-adagio-separated-gallery')) {
        const gallery = product.querySelector('.adagio-product__gallery');
        const image = Array.from(gallery?.children || []).find(figure => figure.dataset.adagioImageId === option.dataset.imageId);
        if (image) {
          const featuredSizes = gallery.firstElementChild.querySelector('img')?.sizes;
          gallery.prepend(image);
          image.querySelector('img').loading = 'eager';
          if (featuredSizes) image.querySelector('img').sizes = featuredSizes;
          gallery.scrollLeft = 0;
        }
      }
      if (changeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    };
    select.addEventListener('change', () => update(true));
    update();
  });
}

initializeAdagioOrdering();
document.addEventListener('shopify:section:load', event => initializeAdagioOrdering(event.target));
